import React from "react";

const DoNotSell = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <main className="flex-grow py-12 px-4">
        <div
          className="max-w-4xl mx-auto bg-white p-10 shadow-xl rounded-xl text-gray-800 text-[21px]">
          <h1 className="text-4xl font-bold mb-4 border-l-4 border-blue-600 pl-4">
            Do Not Sell My Personal Information
          </h1>

          <p className="mb-4">
            Iword Hosting does not sell or share your personal information with anyone. We take your privacy a top priority. We provide this page in accordance with the California Consumer Privacy Act (CCPA/CPRA). And the same privacy standards are applied to all additional 49 United States. While only serving United States at present, we do comply with various countries privacy laws we plan to do business with in the near future.
          </p>

          <p className="mb-4">
            If you would like to make further, or additional, requests that we do not share or disclose your personal data for purposes that may be interpreted as "selling", you may email us at{" "}
            <a href="mailto:support@i-word.net" className="text-blue-600 underline">
              support@i-word.net
            </a>.
          </p>

          <p>
            We will confirm your request and comply in accordance with applicable California privacy laws and apply those same standards to all 50 United States.
          </p>
        </div>
      </main>
    </div>
  );
};

export default DoNotSell;
